import { TestAppState } from "../app";

type FieldPurpose =
  "projectBasic" | "projectReporting" | "itemBasic" | "itemReporting";

/**
 * A report or dashboard card may only be shown when the configuration field it
 * renders is still switched on — a field that is off has no data behind it.
 */
export function isFieldEnabled(
  settings: TestAppState["settings"],
  fieldName: string,
  purpose: FieldPurpose
): boolean {
  return (
    settings?.configuration?.fieldsDefinition?.some(
      (field) =>
        field.fieldName === fieldName &&
        field.purpose === purpose &&
        field.enabled === true
    ) ?? false
  );
}
